import { Deactivation as DeactivationComponent } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../';

export const Deactivation = () => {
  const settings = useSettings();

  return <DeactivationComponent appAlias={meta.alias} {...settings} />;
};
